import { Stack } from '@fluentui/react';
import { stackTokens } from '../SiteHeader';

export interface IHeaderEndContainerProps {
    children: React.ReactNode;
    wrap?: boolean;
}
export function HeaderEndContainer({ children, wrap }: IHeaderEndContainerProps) {
    return (
        <Stack.Item verticalFill align="center" grow={1}>
            <Stack verticalFill horizontal tokens={stackTokens} horizontalAlign="end" verticalAlign="center" wrap={wrap}>
                {children}
            </Stack>
        </Stack.Item>
    );
}
